<div class="toggler">
    <div class="toggler__left-value cursor-pointer" (click)="layout.set('side-by-side')" [pTooltip]="leftValueTooltip()"
        [tooltipPosition]="tooltipPosition()" [class.selected]="layout() === 'side-by-side'">
        <span>
            <i class="bi bi-layout-text-sidebar-reverse"></i>
        </span>
    </div>
    <div class="toggler__right-value cursor-pointer" (click)="layout.set('table')" [pTooltip]="rightValueTooltip()"
        [tooltipPosition]="tooltipPosition()" [class.selected]="layout() === 'table'">
        <span>
            <i class="bi bi-justify"></i>
        </span>
    </div>
</div>